<template>
  <router-link
    :to="{ name: 'InstitutionApplication', params: { language } }"
    :class="['institution-trial-entry', { 'is-english': isEnglish }]"
  >
    <span class="trial-title">{{ isEnglish ? 'Experience In-Depth Research' : '解锁深度研究' }}</span>
    <span class="trial-action">
      {{ isEnglish ? 'Start Free Trial' : '申请试用' }}
      <img v-if="isEnglish" src="@/assets/research-access/arrow-en.svg" alt="" />
      <img v-else src="@/assets/research-access/arrow.svg" alt="" />
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'InstitutionTrialEntry',
  props: {
    language: { type: String, default: 'chinese' }
  },
  computed: {
    isEnglish() { return this.language === 'english'; }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/researchAccess.scss';

.institution-trial-entry {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 56px;
  padding: 12px;
  gap: 12px;
  color: #fff;
  background: linear-gradient(90deg, #ed6f33, #ff753a);
  border-radius: 6px;
  text-decoration: none;
  font-family: 'Research Access Chinese', sans-serif;

  &:focus-visible { outline: 2px solid #a8491c; outline-offset: 3px; }
  .trial-title { font-size: 20px; line-height: 24px; font-weight: 700; }
  .trial-action {
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    width: 121px;
    height: 32px;
    padding: 0 11px;
    border: 1px solid #fff;
    border-radius: 64px;
    font-size: 13px;
    line-height: 19px;
    white-space: nowrap;
    img { width: 20.6512px; height: 20.6512px; }
  }
  &.is-english {
    min-height: 67px;
    padding: 1px 0 8px;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1px;
    font-family: 'Research Access English', Georgia, serif;
    .trial-title { display: flex; align-items: center; justify-content: center; min-height: 35px; font-size: 18px; text-align: center; }
    .trial-action { width: 179px; height: 22px; padding: 0 14px; font-weight: 700; }
    .trial-action img { width: 16px; height: 17.3078px; }
  }
}

@media screen and (max-width: 374px) {
  .institution-trial-entry {
    gap: 8px;
    padding-right: 8px;
    padding-left: 8px;
    .trial-title { font-size: 17px; }
    .trial-action { width: 112px; }
    &.is-english .trial-title { font-size: 16px; }
  }
}
</style>
